import { FC, useContext, useEffect, useMemo } from "react"
import { EnterpriseComplianceDashboardContext } from "../contexts/EcdContext";
import { EnterpriseComplianceFiltersContext } from "../contexts/EcdFiltersContext";
import { EcdTilesEnum } from "../interfaces";
import EcdTopCountiesFlyout from "../flyouts/EcdTopCountiesFlyout";
import { tileFlyoutLink } from "../flyouts/EcdDrillInConfig";
import TopCountiesByGapTable from "../components/TopCountiesTable";
import { FeatureFlagContext } from "@app/feature-flags/FeatureFlagContext";
import Features from "@app/feature-flags/features";
import DashboardTile from "@app/shared/qes-standards/DashboardTile";


const TopCountiesByGap: FC = () => {
    const filtersContext = useContext(EnterpriseComplianceFiltersContext);
    const dashboardContext = useContext(EnterpriseComplianceDashboardContext);
    const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;
    const title = `Top ${window.ecdTopCountiesCount} Counties by Gap Count`;

    useEffect(() => {
        dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.TopCountiesByGap, true);
    }, []);

    useEffect(() => {
        if (dashboardContext.topCountiesByGapData?.length > 0) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.TopCountiesByGap, false);
        }
    }, [dashboardContext.topCountiesByGapData]);

    useEffect(() => {
        if (!!filtersContext.apiReadyFilters) {
            dashboardContext.updateIsTileLoadingMap(EcdTilesEnum.TopCountiesByGap, true);
        }
    }, [filtersContext.apiReadyFilters]);

    const flyoutLinkTitle = useMemo(() => {
        if (!featureFlags.has(Features.ENABLE_ECD_DRILLINS) || dashboardContext.isDataEmptyMap.get(EcdTilesEnum.TopCountiesByGap)) {
            return title;
        }

        return tileFlyoutLink(
            <EcdTopCountiesFlyout counties={dashboardContext.topCountiesByGapData.map((d) => ({ canonicalRegionSetId: d.canonicalRegionSetId, countySSA: d.countySSA, name: d.countyName }))} />,
            "Top Counties by Gap Count Details",
            filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.TopCountiesByGap),
            "top-counties-by-gap__title-flyout",
            title,
        );
    }, [
        filtersContext.isDashboardLoading,
        dashboardContext.topCountiesByGapData,
        featureFlags.has(Features.ENABLE_ECD_DRILLINS),
        dashboardContext.isDataEmptyMap.get(EcdTilesEnum.TopCountiesByGap),
        dashboardContext.isTileLoadingMap.get(EcdTilesEnum.TopCountiesByGap)
    ]);

    return (
        <DashboardTile
            loading={filtersContext.isDashboardLoading || dashboardContext.isTileLoadingMap.get(EcdTilesEnum.TopCountiesByGap)}
            title={!dashboardContext.isDataEmptyMap.get(EcdTilesEnum.TopCountiesByGap) ? flyoutLinkTitle : title}
            widthClass="col-12 col-xl-6"
        >
          <TopCountiesByGapTable tableData={ dashboardContext.topCountiesByGapData } />
        </DashboardTile>
    )
}

export default TopCountiesByGap;